import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader, Label} from 'reactstrap';
import { createSelector } from 'reselect';
import { toggleSelectDcmProfileModal } from '../../../../slices/modals/reducer';
import CustomSelect from '../../../../Components/Common/CustomSelect';
import { setDcmProfileId, setPublishLoader } from '../../../../slices/publish/reducer';
import { setPreloader } from '../../../../slices/layouts/reducer';
import { saveDcmProfile } from '../../../../slices/publish/dcm/thunk';

function DcmProfileModal() {
  const dispatch = useDispatch();
  
  const selectModalState = createSelector(state => state.Modal, state => state.selectDcmProfileModal);  
  const modalState = useSelector(selectModalState);
    
  const selectProfileState = createSelector(state => state.Publish, state => ({
    dcmProfiles: state.dcmProfiles,
    dcmProfileId: state.dcmProfileId
  }));
  const {dcmProfiles, dcmProfileId} = useSelector(selectProfileState);
  
  const [profileState, setProfileState] = useState([]);
  
  useEffect(() => {
    if (dcmProfiles && dcmProfiles.length > 0) {
      setProfileState(dcmProfiles.map(item => {
        return {value:item.profileId, name:`${item.userName} | ${item.accountName}`};
      }));
    }
  }, [dcmProfiles]);

  function closeModal() {
    dispatch(toggleSelectDcmProfileModal());
  }

  function handleProfileSelect(profile) {
    dispatch(setDcmProfileId(profile.value));
  };

  function handleSubmit() {
    dispatch(setPublishLoader(true));
    dispatch(saveDcmProfile());
    dispatch(setPublishLoader(false));
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='sm'>
      <ModalHeader className='p-3' toggle={closeModal}>
        <b>Select Profile For DCM</b>
      </ModalHeader>
      <ModalBody>
        <Label>Profile</Label>
        <CustomSelect 
        tag='div' 
        className='mt=2 form-select'
        placeholder='Select Profile'
        options={profileState}
        onChange={(profile) => handleProfileSelect(profile)}
        />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
        <button className='btn btn-success' onClick={handleSubmit}>Save Profile</button>
      </ModalFooter>
    </Modal>
  )
}

export default DcmProfileModal;